import React, { useEffect, useState } from 'react';
import { create } from 'apisauce';
import { getServer } from '../../Utils/url';
import packageJson from '../../../package.json';

const API = create({
  baseURL: getServer(),
});

export const VersionDisplay = () => {
  const [apiVersion, setApiVersion] = useState('...');

  useEffect(() => {
    const fetchApiVersion = async () => {
      try {
        const response = await API.get('/version');
        if (response.ok && response.data) {
          setApiVersion(response.data.version || response.data);
        } else {
          setApiVersion('N/A');
        }
      } catch (error) {
        setApiVersion('N/A');
      }
    };

    fetchApiVersion();
  }, []);

  return (
    <div className="version-display">
      v.{packageJson.version} | api v.{apiVersion}
    </div>
  );
};
